import {
  IMG_PRINT_GIMHAE_2,
  IMG_PRINT_GIMHEA_1,
  IMG_PRINT_GIMPO_1,
  IMG_PRINT_GIMPO_2,
  IMG_PRINT_INCHEON_T1_1,
  IMG_PRINT_INCHEON_T2_1,
  IMG_PRINT_INCHEON_T2_2,
  IMG_PRINT_MAP_GIMHAE_1,
  IMG_PRINT_MAP_GIMHAE_2,
  IMG_PRINT_MAP_GIMPO_1,
  IMG_PRINT_MAP_INCHEON_1,
  IMG_PRINT_MAP_INCHEON_T2_1,
  IMG_PRINT_MAP_INCHEON_T2_2,
  IMG_PRINT_MAP_JEJU_1,
  IMG_PRINT_JEJU_1,
  IMG_PRINT_INCHEON_T1_2,
  IMG_PRINT_MAP_INCHEON_2,
} from '@repo/assets';
import { VAN_REFUNDABLE_AIRPORT_CODE } from '@repo/types';

export type LocationPrintAirport = Exclude<
  VAN_REFUNDABLE_AIRPORT_CODE,
  'VAN_ETC' | 'UNKNOWN' | 'KIOSK'
>;

type LocationPrint = {
  key: LocationPrintAirport;
  name: string;
  nameKor: string;
};

type LocationPrintDetail = {
  type: { eng: string; kor: string; isFillColor?: boolean }[];
  location: { eng: string; kor: string };
  time: string;
  tel: string;
  img: string;
  map: string;
};

export const LOCATION_PRINT: LocationPrint[] = [
  {
    key: 'ICN_TERMINAL1',
    name: 'Incheon Airport T1',
    nameKor: '인천공항 T1',
  },
  {
    key: 'ICN_TERMINAL2',
    name: 'Incheon Airport T2',
    nameKor: '인천공항 T2',
  },
  {
    key: 'GMP',
    name: 'Gimpo Airport',
    nameKor: '김포공항',
  },
  {
    key: 'KIH',
    name: 'Gimhae Airport',
    nameKor: '김해공항',
  },
  {
    key: 'CJU',
    name: 'Jeju Airport',
    nameKor: '제주공항',
  },
];

export const LOCATION_PRINT_DETAIL: Record<
  LocationPrintAirport,
  LocationPrintDetail[]
> = {
  ICN_TERMINAL1: [
    {
      type: [
        { eng: 'Landside', kor: '일반구역', isFillColor: true },
        { eng: 'Only Cash', kor: '현금결제만 가능' },
      ],
      location: {
        eng: '3F Counter-H Library (K-Books)',
        kor: '3층 H 카운터 부근 서점 (K-Books)',
      },
      time: '06:30 ~ 21:30',
      tel: '032-743-0092',
      img: IMG_PRINT_INCHEON_T1_1,
      map: IMG_PRINT_MAP_INCHEON_1,
    },
    {
      type: [{ eng: 'Airside', kor: '면세구역', isFillColor: true }],
      location: {
        eng: '3F, Near Gate 24, Behind Baskin-Robbins',
        kor: '3층 24번 게이트 배스킨라빈스 뒷편',
      },
      time: '06:00 ~ 22:00',
      tel: '032-743-8320',
      img: IMG_PRINT_INCHEON_T1_2,
      map: IMG_PRINT_MAP_INCHEON_2,
    },
  ],
  ICN_TERMINAL2: [
    {
      type: [{ eng: 'Landside', kor: '일반구역', isFillColor: true }],
      location: { eng: '3F PASCUCCI', kor: '3층 파스쿠찌' },
      time: '06:00 ~ 22:00',
      tel: '032-743-8578',
      img: IMG_PRINT_INCHEON_T2_1,
      map: IMG_PRINT_MAP_INCHEON_T2_1,
    },
    {
      type: [
        { eng: 'Landside', kor: '일반구역', isFillColor: true },
        { eng: 'Only Cash', kor: '현금결제만 가능' },
      ],
      location: {
        eng: '3F Counter-F Travel Mate',
        kor: '3층 F카운터 부근 트레블메이트',
      },
      time: '06:00 ~ 22:00',
      tel: '032-743-4313',
      img: IMG_PRINT_INCHEON_T2_2,
      map: IMG_PRINT_MAP_INCHEON_T2_2,
    },
  ],
  GMP: [
    {
      type: [{ eng: 'Domestic', kor: '국내선' }],
      location: {
        eng: '4F Food court Ple Eating Lounge',
        kor: '4층 푸드코트 Ple Eating Lounge',
      },
      time: '',
      tel: '',
      img: IMG_PRINT_GIMPO_1,
      map: IMG_PRINT_MAP_GIMPO_1,
    },
    {
      type: [{ eng: 'Gimpo Airport Metro', kor: '김포공항역' }],
      location: {
        eng: 'Lotte Mart Gimpo Airport Branch - PRINT CAFE 24',
        kor: '롯데마트 김포공항점 PRINT CAFE 24',
      },
      time: '',
      tel: '',
      img: IMG_PRINT_GIMPO_2,
      map: '',
    },
  ],
  KIH: [
    {
      type: [{ eng: 'Domestic', kor: '국내선' }],
      location: { eng: '2F Zim Carry', kor: '2층 짐캐리' },
      time: 'Open Time : 09:00 ~ 21:00',
      tel: '',
      img: IMG_PRINT_GIMHEA_1,
      map: IMG_PRINT_MAP_GIMHAE_1,
    },
    {
      type: [{ eng: 'International', kor: '국제선' }],
      location: { eng: '3F Zim Carry', kor: '3층 짐캐리' },
      time: 'Open Time : 09:00 ~ 21:20',
      tel: '',
      img: IMG_PRINT_GIMHAE_2,
      map: IMG_PRINT_MAP_GIMHAE_2,
    },
  ],
  CJU: [
    {
      type: [{ eng: 'Domestic', kor: '국내선' }],
      location: {
        eng: '3F Gate3 Information Desk',
        kor: '3층 3번 게이트 부근 안내데스크',
      },
      time: '',
      tel: '',
      img: IMG_PRINT_JEJU_1,
      map: IMG_PRINT_MAP_JEJU_1,
    },
  ],
};
